import React from 'react';
import { Card, Box, Flex, Text, Button } from '../design-system';
import { TiCancel } from 'react-icons/ti';
import { FaRegEdit } from 'react-icons/fa';
import CloseButton from './CloseButton';
import DeleteButton from './DeleteButton';
import { utcToLocal } from '../helpers/utils';

interface CardHeaderProps {
  title: string;
  onEditChange?: (val: boolean) => void;
  isEditing?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  onDelete?: () => void;
  isSingleEntity?: boolean;
  onClose?: () => void;
  updatedAt?: string;
  saving?: boolean;
  isSmall?: boolean;
}

const CardHeader = ({
  title,
  onEditChange,
  isEditing,
  canEdit,
  canDelete,
  onDelete,
  isSingleEntity,
  onClose,
  updatedAt,
  saving = false,
  isSmall = false,
}: CardHeaderProps) => {
  const size = {
    title: isSmall ? 18 : 20,
    updatedAt: isSmall ? 12 : 14,
  };
  return (
    <Card.Header>
      <Flex justifyContent="flex-start" alignItems="center">
        <Text
          id="title-card-text"
          fontWeight={700}
          fontSize={size.title}
          lineHeight={`${size.title}px`}
          mr={3}
        >
          {title}
        </Text>
        {updatedAt && (
          <Text
            fontWeight={500}
            fontSize={size.updatedAt}
            lineHeight={`${size.updatedAt}px`}
            color="grey"
            alignSelf="flex-end"
          >
            {saving
              ? 'Auto-Saving...'
              : `Last Saved: ${utcToLocal(updatedAt).fromNow()}`}
          </Text>
        )}
        <Box justifySelf="flex-end" ml="auto">
          <Button.Group>
            {canEdit && (
              <Button
                id="edit-button"
                onClick={() => onEditChange(!isEditing)}
                variant="primaryText"
              >
                {isEditing ? (
                  <TiCancel title="Cancel" aria-label="Cancel" fontSize={20} />
                ) : (
                  <FaRegEdit title="Edit" aria-label="Edit" fontSize={20} />
                )}
              </Button>
            )}
            {canDelete && <DeleteButton onClick={onDelete} />}
            {isSingleEntity && (
              <CloseButton p={0} onClick={onClose} variant="primaryText" />
            )}
          </Button.Group>
        </Box>
      </Flex>
    </Card.Header>
  );
};

export default CardHeader;
